import API from "../../../store/api";
import { authLogout } from "../../../store/actions/authActions";
import { setAbout, clearAbout } from "../../../store/actions/aboutActions";
import { setMessage } from '../../../store/actions/dialogActions';

export const getAboutBySite = (siteId, bearerAuth) => {
  return async dispatch => {
    API.get(`/api/portal/about/siteId/${siteId}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500)
      .then((response) => {
        if (response.status === 200) {
          dispatch(setAbout(response.body));
        } else if (response.status === 401) {
          dispatch(clearAbout);
          dispatch(authLogout);
        } else {
          dispatch(clearAbout)
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'About Retrieval Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(clearAbout);
      })
  }
}